





















































import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { NotificationInterface } from '@/store/dashboard/notifications/notifications';
import { EventListRequestInterface } from '@/modules/backend';
import { User } from '@/modules/backend/Entities/User';
import UserProfileMenu from '@/layouts/core/drawer/UserProfileMenu.vue';
import NavigationDrawer from '@/layouts/core/drawer/NavigationDrawer.vue';
import Breadcrumbs from '@/components/breadcrumbs/Breadcrumbs.vue';
import Mixin from '@/mixins/base';
import { eventTypeToString } from '@/filters/eventTypeToString';
import { eventTypeColor } from '@/filters/eventTypeColor';
import Searchbar from '@/components/dashboard/Searchbar.vue';
import { DrawerModule } from '@/store/app/drawer/drawer';
import { resolveModule } from '@/store';
import ErrorAlerts from '@/components/errors/ErrorAlerts.vue';

const AuthModule = namespace('app/auth');
const NotificationsModule = namespace('dashboard/notifications');
const Permissions = namespace('dashboard/permissions');

@Component({
  mixins: [Mixin],
  filters: {
    eventTypeToString,
    eventTypeColor,
  },
  components: {
    searchbar: Searchbar,
    breadcrumbs: Breadcrumbs,
    'error-alerts': ErrorAlerts,
    'user-profile-menu': UserProfileMenu,
    'navigation-drawer': NavigationDrawer
  }
})
export default class Dashboard extends Mixins(Mixin) {
  private drawerModule: DrawerModule = resolveModule(DrawerModule);

  @NotificationsModule.Getter('UnreadNotifications')
  private UnreadNotifications!: NotificationInterface[];

  @NotificationsModule.Action('Push')
  private PushNotification!: (payload: NotificationInterface) => Promise<void>;

  @NotificationsModule.Action('MarkAsRead')
  private MarkAsRead!: (payload: NotificationInterface) => Promise<void>;

  @NotificationsModule.Action('Fetch')
  private LoadNotifications!: (payload: EventListRequestInterface) => Promise<void>;

  @Permissions.Action('List')
  private LoadPermissions!: () => Promise<void>;

  @AuthModule.Getter('Info')
  private AuthInfo!: User;

  private menuStateChangedHandler(newState: boolean): void {
    if (this.isMobile) {
      this.drawerModule.setState(newState);
    }
  }

  public async mounted(): Promise<void> {
    await this.LoadNotifications({
      Page: 1
    });
    await this.LoadPermissions();
  }
}
